import PoweredSquareLogo from 'src/assets/images/poweredby-square.svg'
import GigeeLogo from 'src/assets/images/gigee-logo.svg'
import React, { Fragment, memo } from 'react'
import tw from 'twin.macro'
import { useSelector } from 'react-redux'
import { getPartner } from 'src/selectors/partner'
import PoweredLogo from 'src/assets/images/poweredby.svg'

interface Props {
  className?: any
}

// TODO: temporary hardcode
const GigeeId = 'a2ddc684-1253-41c2-94db-6e4810416aee'

const FooterComponent = ({ className }: Props) => {
  const partner = useSelector(getPartner)

  const isGigee = partner?.id === GigeeId

  return (
    <div
      css={[tw`flex flex-row items-center justify-center`, className]}
      data-testid="shared-footer"
    >
      {isGigee ? (
        <Fragment>
          <img src={GigeeLogo} />
          <div css={tw`h-8 w-0.5 bg-shades-200 mx-8`} />
          <img src={PoweredSquareLogo} />
        </Fragment>
      ) : (
        <img src={PoweredLogo} />
      )}
    </div>
  )
}

export const Footer = memo(FooterComponent)
